import React, { Suspense, useEffect, useState } from "react";
import { BrowserRouter } from 'react-router-dom';
import RouterComponent from "./router/Router";
import styled from "styled-components";

const Container = styled.div`
  max-width: 1440px; /* Adjust as needed */
  margin: 0 auto;
  // padding: 0 20px;
`;

const App = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // useEffect(() => {
  //   const handleResize = () => {
  //     setWindowWidth(window.innerWidth);
  //   };

  //   window.addEventListener('resize', handleResize);
  //   return () => {
  //     window.removeEventListener('resize', handleResize);
  //   };
  // }, []);

  return (
    <>
      {/* {windowWidth > 1440 ? (
        <Container>
          <BrowserRouter>
            <Suspense fallback={null}>
              <RouterComponent />
            </Suspense>
          </BrowserRouter>
        </Container>
      ) : ( */}
        <BrowserRouter>
          {/* <Suspense fallback={null}> */}
            <RouterComponent />
          {/* </Suspense> */}
        </BrowserRouter>
      {/* )} */}
    </>
  );
};

export default App;
